import {
  GROUP_MEMBER_PATH,
  PROPERTY_OBJ,
  PROPERTY_WEDDING_DRESS_ID,
  PROPERTY_WEDDING_PHOTO_ID,
  PROPERTY_WEDDING_PLAN_ID,
  SI_YI_TEAM_GROUP_MEMBER_PATH
} from '@constant'
import { dGet } from '@core/utils'
import { HOTEL_MERCHANT, LOCAL_MERCHANT_MAIN } from '@hlj/hlj-constant'
import {
  getMerchantInfo,
  isHotelProperty,
  isWeddingCameraShootingProperty,
  isWeddingDressPhotoProperty,
  isWeddingDressProperty,
  isWeddingEmceeProperty,
  isWeddingMakeupProperty,
  isWeddingPhotographyProperty,
  isWeddingPlanProperty,
  isWeddingRingJewelryProperty
} from '@merchant-backend/util'
import { Modal } from 'hljd'
import { hashHistory } from 'react-router'
/**
 * 获取当前商家类目名称
 * 可传入property_id查找对应商家类目名称
 */

export const getMerchantPropertyName = property_id => {
  if (property_id) {
    return PROPERTY_OBJ[property_id]
  }
  return PROPERTY_OBJ[getMerchantInfo().property_id]
}

export const getPropertyId = () => {
  return getMerchantInfo().property_id
}

/**
 * 是否是酒店子商家
 */
export const isHotelMerchant = () => {
  return getMerchantInfo().shop_type == HOTEL_MERCHANT
}

// 酒店类型是否是婚礼堂
export const isHunlitang = () => {
  return isHotelProperty() && getMerchantInfo().category_id == 13
}
// 酒店类型是否是特餐
export const isSpecialDish = () => {
  return isHotelProperty() && getMerchantInfo().category_id == 3
}
// 酒店类型是四星酒店
export const isFourStarHotel = () => {
  return isHotelProperty() && getMerchantInfo().category_id == 9
}
// 酒店类型是否是五星酒店
export const isFiveStarHotel = () => {
  return isHotelProperty() && getMerchantInfo().category_id == 10
}
// 酒店类型是否是其他酒店
export const isOtherHotel = () => {
  return isHotelProperty() && getMerchantInfo().category_id == 12
}

/**
 * 三大主类目
 */

export const isMainSanDaProperty = () => {
  const property_id = getMerchantInfo().property_id
  const ids = [
    PROPERTY_WEDDING_PLAN_ID,
    PROPERTY_WEDDING_PHOTO_ID,
    PROPERTY_WEDDING_DRESS_ID
  ]
  return ids.findIndex(f => f == property_id) > -1
}

/**
 * 四大 减去 司仪
 */
export const isSanDaProperty = () => {
  return (
    isWeddingPhotographyProperty() ||
    isWeddingCameraShootingProperty() ||
    isWeddingMakeupProperty()
  )
}

/**
 * 三大主类目 + 婚戒 + 酒店
 */

export const isWuDaProperty = () => {
  return (
    isWeddingPlanProperty() ||
    isWeddingDressPhotoProperty() ||
    isWeddingDressProperty() ||
    isHotelProperty() ||
    isWeddingRingJewelryProperty()
  )
}

/**
 * 司仪成员
 */
export const isSiYiMember = () => {
  const { shop_type } = getMerchantInfo()
  return isWeddingEmceeProperty() && shop_type != LOCAL_MERCHANT_MAIN
}

/**
 * 司仪团队
 */
export const isSiYiTeam = () => {
  const { shop_type } = getMerchantInfo()
  return isWeddingEmceeProperty() && shop_type == LOCAL_MERCHANT_MAIN
}

/**
 * 四大减去司仪的成员
 */
export const isSanDaMember = () => {
  const { shop_type } = getMerchantInfo()
  return isSanDaProperty() && shop_type != LOCAL_MERCHANT_MAIN
}

/**
 * 四大减去司仪的团队
 */
export const isSanDaTeam = () => {
  const { shop_type } = getMerchantInfo()
  return isSanDaProperty() && shop_type == LOCAL_MERCHANT_MAIN
}

/**
 * 四大成员
 */
export const isSiDaMember = () => {
  return isSanDaMember() || isSiYiMember()
}

/**
 * 四大团队
 */
export const isSiDaTeam = () => {
  return isSanDaTeam() || isSiYiTeam()
}

/**
 * 是否团队账号（shop_type 为 5）
 */
export const isTeam = () => {
  return isSiDaTeam()
}

/**
 * 成员加入的团队id
 */
export const getGroupId = () => {
  return dGet(getMerchantInfo(), 'group.id')
}

/**
 * 个人账号，没有加入团队
 */
export const memberHasNoGroup = () => {
  return isSiDaMember() && !getGroupId()
}

/**
 * 四大团队是否有成员
 */
export const groupHasNoMember = title => {
  if (isSiDaTeam() && getMerchantInfo().all_member_count == 0) {
    Modal.confirm({
      title,
      okText: '立即添加',
      onOk: () => {
        //
        if (isSanDaTeam()) {
          hashHistory.push(GROUP_MEMBER_PATH)
        }
        if (isSiYiTeam()) {
          hashHistory.push(SI_YI_TEAM_GROUP_MEMBER_PATH)
        }
      }
    })
    return true
  }

  return false
}

/**
 * 体验店推荐
 */
export const isExperienceRecommend = () =>
  getMerchantInfo().experience_recommend == 1

/**
 * 体验店合作
 */
export const isExperienceCollaborate = () =>
  getMerchantInfo().experience_collaborate == 1

/**
 * 是否婚宴酒店-婚礼堂类型
 */
export const isWeddingHall = () => {
  return getMerchantInfo().category_id == 13
}
